import { apiFetch } from './client';

export type PageNature = 'source-grounded' | 'synthesis' | null;

export interface PageRow {
  id: string;
  title: string;
  url: string;
  domain: string | null;
  subdomain: string | null;
  cluster: string | null;
  nature: PageNature;
  quality: number | null;
  source_ids: string[];
  cited_sources: string[];
  broken_citations: string[];
  requires_review: boolean;
  updated_at: string | null;
  created_at: string | null;
}

export interface PagesResponse {
  count: number;
  by_nature: Record<string, number>;
  requires_review_count: number;
  with_broken_citations_count: number;
  pages: PageRow[];
}

export interface PagesQuery {
  nature?: 'source-grounded' | 'synthesis' | 'any';
  requires_review?: 'true' | 'false' | 'any';
  has_broken_citations?: 'true' | 'false' | 'any';
  cited?: string;
  q?: string;
  limit?: number;
}

export function fetchPages(opts: PagesQuery = {}): Promise<PagesResponse> {
  const params = new URLSearchParams();
  if (opts.nature) params.set('nature', opts.nature);
  if (opts.requires_review) params.set('requires_review', opts.requires_review);
  if (opts.has_broken_citations) {
    params.set('has_broken_citations', opts.has_broken_citations);
  }
  if (opts.cited) params.set('cited', opts.cited);
  if (opts.q) params.set('q', opts.q);
  if (opts.limit) params.set('limit', String(opts.limit));
  const qs = params.toString();
  return apiFetch<PagesResponse>(`/api/pages${qs ? `?${qs}` : ''}`);
}
